class ProductDuplicateSkuService extends BaseService
	@register angular.module 'App.Service'
	@inject 'ProductRepository'

	gatherSkus: (product, newVariant, isMultipleSkuEnabled) ->
		skus = @gatherProductSkus(product, isMultipleSkuEnabled)

		skus.push(@gatherProductSkus(newVariant, isMultipleSkuEnabled)...)

		for variant in product.product_variants ? []
			skus.push(@gatherProductSkus(variant, isMultipleSkuEnabled)...)

		return skus

	gatherProductSkus: (product, isMultipleSkuEnabled) ->
		skus = []

		if product.sku?
			skus.push(product.sku)

		if !isMultipleSkuEnabled
			return skus

		for sku in product.product_variant_skus ? product.product_skus ? []
			skus.push(sku.value)

		return skus

	findProductsWithDuplicateSkusByProduct: (product, newVariant, isMultipleSkuEnabled) ->
		allSkus = @gatherSkus(product, newVariant, isMultipleSkuEnabled)

		return @ProductRepository
			.findBySkus(allSkus)
			.then (skuProducts) => @buildSkuProductMap(skuProducts, product.id)

	buildSkuProductMap: (skuProducts, mainProductId) ->
		skuProductMap = {}

		for skuProduct in skuProducts
			if skuProduct.product_id == mainProductId
				continue

			sku = skuProduct.sku
			skuProductMap[sku] ?= []
			skuProductMap[sku].push(skuProduct)

		return skuProductMap
